export default {
    radius: 0.25,
};
